/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Version } from '../models/version';
import { DeletedEntity } from '../models/deleted-entity';
import { PageVersion } from '../models/page-version';

/**
 * Ui Versioning Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiVersioningControllerService extends __BaseService {
  static readonly getVersionByIdUsingGETPath = '/cc-ui/v1/versions/id/{id}';
  static readonly softDeletedEntitiesUsingGETPath =
    '/cc-ui/v1/versions/softDeletedEntities';
  static readonly deleteSoftDeleteEntityUsingDELETEPath =
    '/cc-ui/v1/versions/softDeletedEntities';
  static readonly deleteAllSoftDeleteEntitiesUsingDELETEPath =
    '/cc-ui/v1/versions/softDeletedEntities/all';
  static readonly restoreSoftDeleteUsingPOSTPath =
    '/cc-ui/v1/versions/softDeletedEntities/{entityId}';
  static readonly softDeletedEntitiesByTypeUsingGETPath =
    '/cc-ui/v1/versions/softDeletedEntities/{entityType}';
  static readonly restoreUsingPOSTPath =
    '/cc-ui/v1/versions/{versionId}/restore';
  static readonly getVersionsUsingGETPath =
    '/cc-ui/v1/versions/{versioningKey}';
  static readonly getVersionsPaginatedUsingGETPath =
    '/cc-ui/v1/versions/{versioningKey}/paginated';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getVersionById
   * @param id id
   * @return OK
   */
  getVersionByIdUsingGETResponse(
    id: string,
  ): __Observable<__StrictHttpResponse<Version>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/versions/id/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Version>;
      }),
    );
  }
  /**
   * getVersionById
   * @param id id
   * @return OK
   */
  getVersionByIdUsingGET(id: string): __Observable<Version> {
    return this.getVersionByIdUsingGETResponse(id).pipe(
      __map((_r) => _r.body as Version),
    );
  }

  /**
   * softDeletedEntities
   * @param params The `UiVersioningControllerService.SoftDeletedEntitiesUsingGETParams` containing the following parameters:
   *
   * - `sortBy`: sortBy
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  softDeletedEntitiesUsingGETResponse(
    params: UiVersioningControllerService.SoftDeletedEntitiesUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<DeletedEntity>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sortBy != null)
      __params = __params.set('sortBy', params.sortBy.toString());
    if (params.perPage != null)
      __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null)
      __params = __params.set('page', params.page.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/versions/softDeletedEntities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeletedEntity>>;
      }),
    );
  }
  /**
   * softDeletedEntities
   * @param params The `UiVersioningControllerService.SoftDeletedEntitiesUsingGETParams` containing the following parameters:
   *
   * - `sortBy`: sortBy
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  softDeletedEntitiesUsingGET(
    params: UiVersioningControllerService.SoftDeletedEntitiesUsingGETParams,
  ): __Observable<Array<DeletedEntity>> {
    return this.softDeletedEntitiesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<DeletedEntity>),
    );
  }

  /**
   * deleteSoftDeleteEntity
   * @param id id
   */
  deleteSoftDeleteEntityUsingDELETEResponse(
    id: Array<string>,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (id || []).forEach((val) => {
      if (val != null) __params = __params.append('id', val.toString());
    });
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/versions/softDeletedEntities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteSoftDeleteEntity
   * @param id id
   */
  deleteSoftDeleteEntityUsingDELETE(id: Array<string>): __Observable<null> {
    return this.deleteSoftDeleteEntityUsingDELETEResponse(id).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * deleteAllSoftDeleteEntities
   */
  deleteAllSoftDeleteEntitiesUsingDELETEResponse(): __Observable<
    __StrictHttpResponse<null>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/versions/softDeletedEntities/all`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteAllSoftDeleteEntities
   */
  deleteAllSoftDeleteEntitiesUsingDELETE(): __Observable<null> {
    return this.deleteAllSoftDeleteEntitiesUsingDELETEResponse().pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * restoreSoftDelete
   * @param entityId entityId
   * @return OK
   */
  restoreSoftDeleteUsingPOSTResponse(
    entityId: string,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/versions/softDeletedEntities/${encodeURIComponent(
          String(entityId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * restoreSoftDelete
   * @param entityId entityId
   * @return OK
   */
  restoreSoftDeleteUsingPOST(entityId: string): __Observable<string> {
    return this.restoreSoftDeleteUsingPOSTResponse(entityId).pipe(
      __map((_r) => _r.body as string),
    );
  }

  /**
   * softDeletedEntitiesByType
   * @param params The `UiVersioningControllerService.SoftDeletedEntitiesByTypeUsingGETParams` containing the following parameters:
   *
   * - `entityType`: entityType
   *
   * - `sortBy`: sortBy
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  softDeletedEntitiesByTypeUsingGETResponse(
    params: UiVersioningControllerService.SoftDeletedEntitiesByTypeUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<DeletedEntity>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.sortBy != null)
      __params = __params.set('sortBy', params.sortBy.toString());
    if (params.perPage != null)
      __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null)
      __params = __params.set('page', params.page.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/versions/softDeletedEntities/${encodeURIComponent(
          String(params.entityType),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DeletedEntity>>;
      }),
    );
  }
  /**
   * softDeletedEntitiesByType
   * @param params The `UiVersioningControllerService.SoftDeletedEntitiesByTypeUsingGETParams` containing the following parameters:
   *
   * - `entityType`: entityType
   *
   * - `sortBy`: sortBy
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  softDeletedEntitiesByTypeUsingGET(
    params: UiVersioningControllerService.SoftDeletedEntitiesByTypeUsingGETParams,
  ): __Observable<Array<DeletedEntity>> {
    return this.softDeletedEntitiesByTypeUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<DeletedEntity>),
    );
  }

  /**
   * restore
   * @param versionId versionId
   * @return OK
   */
  restoreUsingPOSTResponse(
    versionId: string,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/versions/${encodeURIComponent(String(versionId))}/restore`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * restore
   * @param versionId versionId
   * @return OK
   */
  restoreUsingPOST(versionId: string): __Observable<{}> {
    return this.restoreUsingPOSTResponse(versionId).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * getVersions
   * @param params The `UiVersioningControllerService.GetVersionsUsingGETParams` containing the following parameters:
   *
   * - `versioningKey`: versioningKey
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  getVersionsUsingGETResponse(
    params: UiVersioningControllerService.GetVersionsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<Version>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.perPage != null)
      __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null)
      __params = __params.set('page', params.page.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/versions/${encodeURIComponent(
          String(params.versioningKey),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Version>>;
      }),
    );
  }
  /**
   * getVersions
   * @param params The `UiVersioningControllerService.GetVersionsUsingGETParams` containing the following parameters:
   *
   * - `versioningKey`: versioningKey
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  getVersionsUsingGET(
    params: UiVersioningControllerService.GetVersionsUsingGETParams,
  ): __Observable<Array<Version>> {
    return this.getVersionsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<Version>),
    );
  }

  /**
   * getVersionsPaginated
   * @param params The `UiVersioningControllerService.GetVersionsPaginatedUsingGETParams` containing the following parameters:
   *
   * - `versioningKey`: versioningKey
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  getVersionsPaginatedUsingGETResponse(
    params: UiVersioningControllerService.GetVersionsPaginatedUsingGETParams,
  ): __Observable<__StrictHttpResponse<PageVersion>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.perPage != null)
      __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null)
      __params = __params.set('page', params.page.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/versions/${encodeURIComponent(
          String(params.versioningKey),
        )}/paginated`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PageVersion>;
      }),
    );
  }
  /**
   * getVersionsPaginated
   * @param params The `UiVersioningControllerService.GetVersionsPaginatedUsingGETParams` containing the following parameters:
   *
   * - `versioningKey`: versioningKey
   *
   * - `perPage`: perPage
   *
   * - `page`: page
   *
   * @return OK
   */
  getVersionsPaginatedUsingGET(
    params: UiVersioningControllerService.GetVersionsPaginatedUsingGETParams,
  ): __Observable<PageVersion> {
    return this.getVersionsPaginatedUsingGETResponse(params).pipe(
      __map((_r) => _r.body as PageVersion),
    );
  }
}

module UiVersioningControllerService {
  /**
   * Parameters for softDeletedEntitiesUsingGET
   */
  export interface SoftDeletedEntitiesUsingGETParams {
    /**
     * sortBy
     */
    sortBy?:
      | 'ID'
      | 'CREATION_DATE'
      | 'CREATED_BY'
      | 'LAST_MODIFIED_DATE'
      | 'LAST_MODIFIED_BY';

    /**
     * perPage
     */
    perPage?: number;

    /**
     * page
     */
    page?: number;
  }

  /**
   * Parameters for softDeletedEntitiesByTypeUsingGET
   */
  export interface SoftDeletedEntitiesByTypeUsingGETParams {
    /**
     * entityType
     */
    entityType:
      | 'CLUSTER'
      | 'BLUE_PRINT'
      | 'TEMPLATE_INPUT'
      | 'CONTROL_PLANE'
      | 'IAC'
      | 'ARTIFACT_CI'
      | 'USER_GROUP'
      | 'ACCOUNT'
      | 'ARTIFACTORY';

    /**
     * sortBy
     */
    sortBy?:
      | 'ID'
      | 'CREATION_DATE'
      | 'CREATED_BY'
      | 'LAST_MODIFIED_DATE'
      | 'LAST_MODIFIED_BY';

    /**
     * perPage
     */
    perPage?: number;

    /**
     * page
     */
    page?: number;
  }

  /**
   * Parameters for getVersionsUsingGET
   */
  export interface GetVersionsUsingGETParams {
    /**
     * versioningKey
     */
    versioningKey: string;

    /**
     * perPage
     */
    perPage?: number;

    /**
     * page
     */
    page?: number;
  }

  /**
   * Parameters for getVersionsPaginatedUsingGET
   */
  export interface GetVersionsPaginatedUsingGETParams {
    /**
     * versioningKey
     */
    versioningKey: string;

    /**
     * perPage
     */
    perPage?: number;

    /**
     * page
     */
    page?: number;
  }
}

export { UiVersioningControllerService };
